export var getRowTextValue = function(rowValue) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _separator = options.separator, separator = _separator === void 0 ? ", " : _separator;
    var content = [];
    try {
        var isInlinable = true;
        var contentEntries = [].concat(rowValue).map(function(rawValue) {
            try {
                if (typeof rawValue === "object" && typeof (rawValue === null || rawValue === void 0 ? void 0 : rawValue.value) === "string") {
                    // The `free-text` row type has this shape
                    return rawValue.value;
                }
                var parsedValue = JSON.parse(rawValue);
                if (typeof parsedValue !== "object") {
                    return rawValue;
                } else if (typeof parsedValue === "object" && !parsedValue.description) {
                    return parsedValue.label;
                }
                var html = parsedValue.description;
                var div = document.createElement("div");
                div.innerHTML = html;
                if (div.children.length === 1 && div.children[0].tagName === "P") {
                    // Get rid of the wrapping <p> to keep it in-line
                    var extractedHtml = div.children[0].innerHTML;
                    return [
                        html,
                        extractedHtml
                    ];
                }
                isInlinable = false;
                return html;
            } catch (e) {
                isInlinable = false;
                return rawValue;
            }
        }).map(function(value) {
            return Array.isArray(value) ? value : [
                value,
                value
            ];
        });
        content = contentEntries.map(function(e) {
            return e[isInlinable ? 1 : 0];
        }).join(isInlinable ? separator : "\n");
    } catch (err) {
        console.error(err);
        return "";
    }
    return content;
};
